import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom';

import Header from "./Header";
import Sidebar from "./Sidebar";
import { useSelector } from 'react-redux';

function Layout() {
	const reduxAccount = useSelector(state => state.account)
	useEffect(() => {
		const disableAutoFill = () => {
			const inputs = document.querySelectorAll('input:not([autoComplete])');
			inputs.forEach(input => {
				input.setAttribute('autoComplete', '123123123123asdasdasdasd');
			});
		};

		disableAutoFill();
	}, []);

	return (
		<div id="layout-wrapper" className={`${reduxAccount?.role?.toLowerCase()}`}>
			<Header />
			<Sidebar />
			<div className="main-content">
				<Outlet />
			</div>
		</div>
	)
}

export default Layout